import { model as i18n } from '!/i18n'
import { combine } from 'effector'
import { model as paymentModel } from '~/features/payment/generic'
import type { PaymentItem } from './index.h'

export const $paymentButtonTranslation = combine(
  i18n.$t,
  paymentModel.$externalPaymentEnabled,
  ({ t }, externalPaymentEnabled) =>
    (entity: PaymentItem | null) =>
      externalPaymentEnabled
        ? t('how_to_watch')
        : t('purchase_for', {
            currency: entity?.minCurrency,
            price: entity?.minPrice,
          })
)
